import { useState, createContext, ReactNode, useContext } from "react";
import NotificationsPopover from "./notifications-popover";

type NotificationToggleContextType = {
  isToggled: boolean;
  setIsToggled: (value: boolean) => void;
};

const NotificationToggleContext = createContext<
  NotificationToggleContextType | undefined
>(undefined);

export const NotificationToggleProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [isToggled, setIsToggled] = useState(false);

  return (
    <NotificationToggleContext.Provider value={{ isToggled, setIsToggled }}>
      {children}
    </NotificationToggleContext.Provider>
  );
};

export const useNotificationToggle = () => {
  return useContext(NotificationToggleContext);
};

export default function NotificationsIcon({
  className,
  counter,
  ...props
}: React.HTMLAttributes<HTMLElement> & {
  counter?: number;
}) {
  return (
    <NotificationToggleProvider>
      <NotificationsPopover className={className} counter={counter}>
        {props.children}
      </NotificationsPopover>
    </NotificationToggleProvider>
  );
}
